import { markRaw } from 'vue'
import RecruiterPlacementTermsColumn from './RecruiterPlacementTermsColumn.vue'
import RecruiterPlacementOwnershipColumn from './RecruiterPlacementOwnershipColumn.vue'
import RecruiterPlacementContractColumn from './RecruiterPlacementContractColumn.vue'
import {
  RecruiterPlacementTermsColumnFragmentDoc,
  RecruiterPlacementOwnershipColumnFragmentDoc,
  RecruiterPlacementContractColumnFragmentDoc,
  FeeApplication,
} from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { ColumnMaps } from '@/components/GraphqlDataTable/columns/types'

const columns: ColumnMaps = {
  RecruiterPlacementTermsColumn: {
    fragment: RecruiterPlacementTermsColumnFragmentDoc,
    component: markRaw(RecruiterPlacementTermsColumn),
    columnDef: {
      title: $t('Terms'),
      key: 'terms',
      renderUsing: {
        component: markRaw(RecruiterPlacementTermsColumn),
        componentProps: (row) => ({ row }),
      },
    },
    dataDescriber: [
      {
        title: 'Recruiter fee',
        extraction: (row) =>
          row.fees
            .filter((fee) => fee.application === FeeApplication.Additive)
            .map((fee) => fee.formattedRate)
            .join(' + ') || '-',
      },
      {
        title: 'Ownership days',
        extraction: (row) => `${row.recruiterOwnershipDays}`,
      },
    ],
  },
  RecruiterPlacementOwnershipColumn: {
    fragment: RecruiterPlacementOwnershipColumnFragmentDoc,
    component: markRaw(RecruiterPlacementOwnershipColumn),
    columnDef: {
      title: $t('Ownership'),
      key: 'ownership',
      renderUsing: {
        component: markRaw(RecruiterPlacementOwnershipColumn),
        componentProps: (row) => ({ row }),
      },
    },
    dataDescriber: [
      {
        title: 'Ownership status',
        extraction: (row) => (row.recruiterOwnershipIsExpired ? 'Expired' : 'Active'),
      },
      {
        title: 'Days left',
        extraction: (row) => `${row.recruiterOwnershipDaysLeft}`,
      },
    ],
  },
  RecruiterPlacementContractColumn: {
    fragment: RecruiterPlacementContractColumnFragmentDoc,
    component: markRaw(RecruiterPlacementContractColumn),
    columnDef: {
      title: $t('Contract'),
      key: 'contract',
      renderUsing: {
        component: markRaw(RecruiterPlacementContractColumn),
        componentProps: (row) => ({ row }),
      },
      ignoreClickForRowSelection: true,
    },
    dataDescriber: [
      {
        title: 'Contract number',
        extraction: (row) => `#${row.number}`,
      },
    ],
  },
}

export default columns
